import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";

import { OptionalFormattedMessage } from "../../../i18n/OptionalFormattedMessage";
import { DrilldownRoutePage } from "../drilldown.types";
import { Desktop, Mobile } from "../../../hocs/Responsive";

const TITLES = {
  webfilter: "blocked_activity",
  malware: "malware_and_phishing_blocked",
  botnet: "botnet_blocked",
};

interface Props {
  page: DrilldownRoutePage;
}

export const DrilldownTitle = ({ page }: Props) => {
  return (
    <Fragment>
      <Desktop>
        <h1 className={"drilldowns__title"}>
          <FormattedMessage id={TITLES[page]} />
        </h1>
      </Desktop>
      <Mobile>
        <h2 className={"drilldowns__title"}>
          <FormattedMessage id={TITLES[page]} />
        </h2>
      </Mobile>
      <p className={"drilldowns__subtitle"}>
        <OptionalFormattedMessage id={`${page}_drilldown_subtitle`} />
      </p>
    </Fragment>
  );
};
